// App.js
import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  Navigate,
} from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Grid,
  Toolbar,
  Button,
  Menu,
  MenuItem,
} from "@material-ui/core";

import Home from "./Home";
import Lessons from "./Lessons";
import Pricing from "./Pricing";
import Footer from "./Footer";
import Register from "./Register";
import SwimJourney from "./SwimJourney";
import logo from "../img/logo.jpg";
import Policy from "./Policy";

const useStyles = makeStyles((theme) => ({
  shell: {
    minHeight: "100vh", // full viewport height
    display: "flex",
    flexDirection: "column", // vertical layout
  },
  main: {
    flex: "1 0 auto", // main content expands
  },
  footer: {
    flexShrink: 0, // footer stays at the bottom
  },
  header: {
    backgroundColor: "#e4943b",
  },
  logoBox: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
  },
  logo: {
    userSelect: "none",
    pointerEvents: "none",
    width: "300px",
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "200px",
    },
  },
  navLinkBox: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    paddingBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  navLink: {
    marginLeft: "6px",
    padding: "0.4rem 0.8rem",
    color: "#e4943b",
    backgroundColor: "white",
    borderRadius: "3px",
    textDecoration: "none !important",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "transparent",
      fontWeight: "bold",
    },
  },
  navLinkMenu: {
    marginLeft: "6px",
    padding: "0.4rem 0.8rem",
    color: "#e4943b",
    backgroundColor: "white",
    borderRadius: "3px",
    textDecoration: "none !important",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "transparent",
      color: "white",
      border: "2px solid white",
      fontWeight: "bold",
    },
  },
}));

function App() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <BrowserRouter>
      <div className={classes.shell}>
        {/* HEADER */}
        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <Grid container direction="row">
              <Grid item xs={0} sm={4}></Grid>
              <Grid item xs={9} sm={4} className={classes.logoBox}>
                <img className={classes.logo} src={logo} alt="Logo" />
              </Grid>
              <Grid item xs={3} sm={4} className={classes.navLinkBox}>
                <Button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleMenuClick}
                  className={classes.navLinkMenu}
                >
                  Menu
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/" className={classes.navLink}>
                      Home
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/lessons" className={classes.navLink}>
                      Our Lessons
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/pricing" className={classes.navLink}>
                      Our Pricing
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/swimjourney" className={classes.navLink}>
                      Swim Journey
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/register" className={classes.navLink}>
                      Register
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <NavLink to="/policy" className={classes.navLink}>
                      Program Policies
                    </NavLink>
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        {/* MAIN CONTENT */}
        <main className={classes.main}>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/lessons" element={<Lessons />}></Route>
            <Route path="/pricing" element={<Pricing />}></Route>
            <Route path="/register" element={<Register />}></Route>
            <Route path="/swimjourney" element={<SwimJourney />}></Route>
            <Route path="/policy" element={<Policy />}></Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        {/* FOOTER */}
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
